import { appPaths } from "../Common";
import { BreadcrumbMap } from "../Layout";

export const breadcrumbsMap: BreadcrumbMap = {
  [appPaths.overview.root]: {
    path: appPaths.overview.root
  }
};
